import React from 'react';
import PropTypes from 'prop-types';

const FilterListComponent = (props) => {
  const {
    visible,
    headline,
    renderElements,
    onClose,
    mobile,
  } = props;
  let className = 'au-vacancy-filter-list';
  if (visible) {
    className += ' visible';
  }
  if (mobile) {
    className += ' mobile';
  }
  return (
    <div className={className}>
      <span>{headline}</span>
      <button
        type="button"
        onClick={() => {
          onClose();
        }}
      >
        c
      </button>
      <ul className="resetlist">
        {renderElements}
      </ul>
    </div>
  );
};

FilterListComponent.defaultProps = {
  mobile: false,
};

FilterListComponent.propTypes = {
  mobile: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
  headline: PropTypes.string.isRequired,
  renderElements: PropTypes.arrayOf(PropTypes.element).isRequired,
  onClose: PropTypes.func.isRequired,
};

FilterListComponent.displayName = 'FilterListComponent';
export default FilterListComponent;
